import { render, staticRenderFns } from "./confirm-email-test-send-modal.vue?vue&type=template&id=cbfd8366"
import script from "./confirm-email-test-send-modal.vue?vue&type=script&lang=js"
export * from "./confirm-email-test-send-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports